import { makeStyles } from '@fluentui/react-components';
import { FC } from 'react';
import { ConfirmOptions } from '../../Contexts/ConfirmContext';
import { CDialog } from './CDialog';

const useStyles = makeStyles({
    message: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
});

interface Props extends ConfirmOptions {
    onConfirm: () => void;
    onCancel: () => void;
}

const ConfirmDialog: FC<Props> = ({ title, message, show, onConfirm, onCancel, confirmText, cancelText }) => {
    const classes = useStyles();
    return (
        <CDialog open={show} title={title} onPrimaryAction={onConfirm} primaryActionText={confirmText} onSecondaryAction={onCancel} secondaryActionText={cancelText}>
            <div className={classes.message}>{message}</div>
        </CDialog>
    );
};

export default ConfirmDialog;
